import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { CheckCircle } from "lucide-react";

interface SuccessStepProps {
  planName?: string;
  isContractor?: boolean;
}

const SuccessStep: React.FC<SuccessStepProps> = ({
  planName,
  isContractor = false,
}) => {
  const navigate = useNavigate();

  // For contractor plans, redirect to login page
  useEffect(() => {
    if (isContractor) {
      setTimeout(() => {
        navigate("/login");
      }, 8000); // Redirect after 8 seconds
    }
  }, [isContractor, navigate]);

  return (
    <div className="max-w-md mx-auto text-center space-y-6">
      <div className="flex justify-center">
        <CheckCircle className="h-16 w-16 text-primary" />
      </div>

      <div>
        <h2 className="text-2xl font-bold">Welcome Aboard!</h2>
        <p className="text-muted-foreground mt-2">
          Your {planName} subscription has been activated successfully.
        </p>
      </div>

      <div className="space-y-4 bg-muted/50 p-6 rounded-lg">
        <h3 className="font-semibold">What's Next?</h3>
        <ul className="text-sm space-y-2 text-left">
          <li>✓ Your account has been created</li>
          <li>✓ Your subscription is now active</li>
          <li>✓ You'll receive a confirmation email shortly</li>
          {isContractor && (
            <li className="font-medium text-secondary">
              You will be redirected to login in a few seconds...
            </li>
          )}
        </ul>
      </div>

      {isContractor ? (
        <div className="pt-4 space-y-4">
          <Button onClick={() => navigate("/login")} className="w-full">
            Go to Login Page
          </Button>
        </div>
      ) : (
        <div className="pt-4 space-y-4">
          <Button onClick={() => navigate("/dashboard")} className="w-full">
            Go to Dashboard
          </Button>

          <Button
            variant="outline"
            onClick={() => navigate("/settings")}
            className="w-full"
          >
            View Account Settings
          </Button>
        </div>
      )}

      <div className="text-sm text-muted-foreground">
        <p>Need help getting started?</p>
        <a href="/help" className="text-primary hover:underline">
          Check out our quick start guide
        </a>
      </div>
    </div>
  );
};

export default SuccessStep;
